import { PaymentDirection } from '@cpce/database/enums';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PendingPaymentsPage } from '@/features/treasury/components/PendingPaymentsPage';

export const Route = createFileRoute('/$commiteeSlug/treasury/pending-payments')({
  validateSearch: z.object({ dueByToday: z.boolean().optional() }),
  component: PendingPaymentsRoute,
});

function PendingPaymentsRoute() {
  const { dueByToday } = Route.useSearch();
  return <PendingPaymentsPage direction={PaymentDirection.inflow} dueByToday={!!dueByToday} />;
}
